<template>
  <span>
    <ProgressSpinner
      v-if="jobsProvider.loading && !(jobsProvider.runningJobs && jobsProvider.runningJobs.length)"
      style="width:22px;height:22px"
      strokeWidth="4"
    />
    <template v-else>
      <Message
        v-if="jobsProvider.error"
        severity="warn"
        :closable="false"
        class="tw-mb-2"
      >
        Jobs status unavailable ({{ jobsProvider.error.message || 'error' }}). Showing last known state.
      </Message>
      <slot v-bind="{ runningJobs: jobsProvider.runningJobs || [] }" />
    </template>
  </span>
</template>

<script>
export default {
  inject: ['jobsProvider'],
}
</script>
